const generalStrings = {
  dashboard: {
    campaignInsightsTitle: 'Campaign Insignts',
    allCampaignsInsightsTitle: 'All Campaigns',
    runningCampaignsInsightsTitle: 'Running Campaigns',
    scheduledCampaignsInsightsTitle: 'Scheduled Campaigns',
    expiredCampaignsInsightsTitle: 'Expired Campaigns',
    inactiveCampaignsInsightsTitle: 'Inactive Campaigns',
  },

  notFound: {
    title: 'You went off limits here',
    subTitle: 'Choose a tab from the sidebar to continue browsing',
  },
};

export default generalStrings;
